import * as z from "zod";

export const updateReplenishmentRequestViewFolder = {
  name: "updateReplenishmentRequestViewFolder" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
